import { render, staticRenderFns } from "./reminder-schedule.vue?vue&type=template&id=2c5d8200&scoped=true&"
import script from "./reminder-schedule.vue?vue&type=script&lang=js&"
export * from "./reminder-schedule.vue?vue&type=script&lang=js&"
import style0 from "./reminder-schedule.vue?vue&type=style&index=0&id=2c5d8200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d8200",
  null
  
)

export default component.exports